import React, { useState, useRef, useEffect } from "react";

import {
    Box,
    TextField,
    Switch,
    FormControlLabel,
    Grid,
    styled,
    FormControl,
    InputLabel,
    Select,
    Chip,
    MenuItem,
    Checkbox,
    ListItemText,
    FormHelperText,
    OutlinedInput,
} from '@mui/material';

import {
    LoadingButton
} from '@mui/lab';

// import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from 'formik';
import { useLocations, locationTypes, targetTypes } from "../../../hooks/api/useLocations";
import { useUsers, userTypes, targetTypes as targetWorker } from '../../../hooks/api/useUsers';
import { initialValues, validationSchema } from "../../../schema/locations/zoneSchema";

import { useAppContextFeatures } from "../../../context/AppContext";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { spliceString } from "../../../utils/formatString"
// import { CommonIcons, icons } from "../../../common/CommonIcons";
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useTranslations } from "../../../hooks/useTranslations";

const StyledCard = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function NewArea(
    {
        parentId,
        handleOnSuccess,
    }
) {
    const { t } = useTranslations({ ns: ["common", "@location"] })

    // const { id } = useParams();
    const { promptMessage } = useSystemPrompt();
    const { isLoading, create, get, list: listRack } = useLocations({ locationType: locationTypes.zone, targetType: targetTypes.zone });
    const { list: listWorker } = useUsers({ userType: userTypes.worker });

    const { setSystemLoading } = useAppContextFeatures();
    const [data, setData] = useState()
    const [dataRacks, setDataRacks] = useState()
    const [dataworkers, setDataWorkers] = useState()

    // const navigate = useNavigate();
    // const { getRoute } = useSystemRoutes(routeTypes.admin);

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            // change rack Id into array object
            let newRackId = []

            values.rackId.forEach(e => {
                newRackId.push({
                    rack_id: e
                })
            })

            // change worker Id into array object
            let newUserId = []

            values.workerId.forEach(e => {
                newUserId.push({
                    user_id: e
                })
            })

            let data = {
                zone: {
                    location_id: parentId,
                    zone_name: currentValues?.zoneName,
                    zone_code: currentValues?.zoneCode,
                    // sequence: currentValues?.sequence,
                    sequence: currentValues?.sequence,
                    is_default: currentValues?.defaultStatus ? 1 : 0,
                    status: currentValues?.status ? 1 : 0,
                },
                racks: newRackId,
                workers: newUserId
            }

            console.log('data', data)

            const response = await create({ data });

            promptMessage(true, `${response?.message}`)

            if (handleOnSuccess) handleOnSuccess()

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const fetchRackData = async (props) => {

        try {

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [],
                sortInfo: {
                    id: "rack_name",
                    dir: 0,
                }
            }

            props.locationType = locationTypes.rack
            props.parentId = parentId

            const { data } = await listRack(props)

            setDataRacks(data?.racks)

        } catch (error) {
            promptMessage(false, `Error getting results (${error?.message})`)
        }
    }

    const fetchWorkerData = async (props) => {

        try {

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [],
                sortInfo: {
                    id: "username",
                    dir: 0,
                }
            }

            props.userType = userTypes.worker

            const { data } = await listWorker(props)

            setDataWorkers(data?.workers)

        } catch (error) {
            promptMessage(false, `Error getting results (${error?.message})`)
        }
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    useEffect(() => {

        fetchRackData()
        fetchWorkerData()

    }, [])

    const getRackOptionNameByIds = (optionIdArray) => {

        if (!optionIdArray) return []

        dataRacks.filter(i => i.rackId === parentId)

        let optionNames = [];

        dataRacks.forEach((e) => {
            // e.options.forEach((e2) => {
            // if(e2.option_key === optionIdArray){
            if (optionIdArray.includes(e.id)) {
                optionNames.push(e.rack_name)
            }
            // })
        })

        return optionNames
    }

    const getWorkerOptionNameByIds = (optionIdArray) => {

        if (!optionIdArray) return []

        dataworkers.filter(i => i.workerId === parentId)

        let optionNames = [];

        dataworkers.forEach((e) => {
            // e.options.forEach((e2) => {
            // if(e2.option_key === optionIdArray){
            if (optionIdArray.includes(e.user_id)) {
                optionNames.push(e.username)
            }
            // })
        })

        return optionNames
    }

    const { touched, values, errors, handleChange, handleSubmit, setFieldValue } = formik;

    const RenderForm = () => {

        return (

            <form onSubmit={handleSubmit}>
                <StyledCard>
                    <Grid container spacing={0}>

                        <Grid item xs={12} sm={12} md={12}>
                            <Grid container spacing={0.5}>

                                <Grid item xs={6} sm={6} md={4}>
                                    <FormControlLabel
                                        sx={{
                                            marginLeft: '1px'
                                        }}
                                        control={
                                            <Switch
                                                name="status"
                                                checked={Boolean(values.status)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("status", checked);
                                                }}
                                            />
                                        }
                                        label={
                                            Boolean(values.status) ? t("enabled") : t("disabled")
                                        }
                                    />
                                </Grid>

                                <Grid item xs={6} sm={6} md={8}>
                                    <></>
                                </Grid>

                                {/* <Grid item xs={6} sm={6} md={4}> 
                                    <FormControlLabel 
                                        sx={{
                                            marginLeft:'1px'
                                        }}
                                        control={
                                            <Switch 
                                                name="defaultStatus" 
                                                checked={Boolean(values.defaultStatus)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("defaultStatus", checked);
                                                }}
                                            />
                                        }     
                                        label={
                                            Boolean(values.defaultStatus)? "Default" : "Not Default"
                                        }
                                    />
                                </Grid> */}

                                <Grid item xs={12} sm={12} md={8}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        autoFocus
                                        fullWidth
                                        name={"zoneName"}
                                        label={t("zoneName")}
                                        type="text"
                                        variant="outlined"
                                        value={values?.zoneName}
                                        onChange={handleChange}
                                        error={touched.zoneName && Boolean(errors.zoneName)}
                                        helperText={touched.zoneName && errors.zoneName}
                                    />
                                </Grid>

                                <Grid item xs={6} sm={6} md={2}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"zoneCode"}
                                        label={t("zoneCode")}
                                        type="text"
                                        variant="outlined"
                                        value={values.zoneCode}
                                        onChange={handleChange}
                                        error={touched.zoneCode && Boolean(errors.zoneCode)}
                                        helperText={touched.zoneCode && errors.zoneCode}
                                    />
                                </Grid>

                                <Grid item xs={6} sm={6} md={2}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"sequence"}
                                        label={t("sortNo")}
                                        type="text"
                                        variant="outlined"
                                        value={values.sequence}
                                        onChange={handleChange}
                                        error={touched.sequence && Boolean(errors.sequence)}
                                        helperText={touched.sequence && errors.sequence}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <FormControl
                                        margin="dense"
                                        fullWidth
                                        size="small"
                                        error={touched.rackId && Boolean(errors.rackId)}
                                    >
                                        <InputLabel id="rack">{t('rack')}</InputLabel>

                                        <Select
                                            labelId="rackId"
                                            label={t("rack")}
                                            name={"rackId"}
                                            onChange={(event) => {
                                                setFieldValue("rackId", event.target.value)
                                            }}
                                            value={values.rackId.length ? values.rackId : []}
                                            renderValue={(selected) => {

                                                return (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {
                                                            getRackOptionNameByIds(selected).map((i, index) => (
                                                                <Chip
                                                                    key={index}
                                                                    // color={'red'}
                                                                    label={spliceString({ val: i, maxLength: 20 })}
                                                                />
                                                            ))
                                                        }
                                                    </Box>
                                                )

                                            }}
                                            multiple
                                            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                        >
                                            {
                                                dataRacks?.map((i, index) => {
                                                    return (
                                                        <MenuItem
                                                            key={index}
                                                            value={i?.id}
                                                        >
                                                            <Checkbox checked={values.rackId.indexOf(i?.id) > -1} />
                                                            <ListItemText
                                                                primary={`${i.rack_name}`}
                                                            />
                                                        </MenuItem>
                                                    )
                                                })
                                            }

                                        </Select>
                                        <FormHelperText>
                                            {touched.rackId && errors.rackId}
                                        </FormHelperText>

                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <FormControl
                                        margin="dense"
                                        fullWidth
                                        size="small"
                                        error={touched.workerId && Boolean(errors.workerId)}
                                    >
                                        <InputLabel id="worker">{t('worker')}</InputLabel>

                                        <Select
                                            labelId="workerId"
                                            label={t("worker")}
                                            name={"workerId"}
                                            onChange={(event) => {
                                                setFieldValue("workerId", event.target.value)
                                            }}
                                            value={values.workerId.length ? values.workerId : []}
                                            renderValue={(selected) => {

                                                return (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {
                                                            getWorkerOptionNameByIds(selected).map((i, index) => (
                                                                <Chip
                                                                    key={index}
                                                                    // color={'red'}
                                                                    label={spliceString({ val: i, maxLength: 20 })}
                                                                />
                                                            ))
                                                        }
                                                    </Box>
                                                )

                                            }}
                                            multiple
                                            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                        >
                                            {
                                                dataworkers?.map((i, index) => {
                                                    return (
                                                        <MenuItem
                                                            key={index}
                                                            value={i?.user_id}
                                                        >
                                                            <Checkbox checked={values.workerId.indexOf(i?.user_id) > -1} />
                                                            <ListItemText
                                                                primary={`${i.username}`}
                                                            />
                                                        </MenuItem>
                                                    )
                                                })
                                            }

                                        </Select>
                                        <FormHelperText>
                                            {touched.workerId && errors.workerId}
                                        </FormHelperText>

                                    </FormControl>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </StyledCard>
                <Box
                    sx={{
                        mx: 2,
                        mr: 2
                    }}
                >
                    <LoadingButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        loading={isLoading}
                    >
                        {t('saveChanges')}
                    </LoadingButton>
                </Box>
            </form >
        )
    }

    return (
        <Box>

            {RenderForm()}

        </Box>
    )
}